import { add, multiply } from "dinero.js";

import { Dinero, getDinero } from "../../utils/money";
import { IBasket, ICustomerDetails } from "./models";

export const getBasketTotal = (basket: IBasket): Dinero => {
    return basket.lines.reduce((memo, line) => {
        const linePrice = multiply(
            getDinero(line.price_excl_tax),
            line.quantity,
        );
        return add(memo, linePrice);
    }, getDinero(0));
};

export const isProtectedUser = (user: ICustomerDetails): boolean => {
    return user.groups.includes("Customer Service Representatives");
};
